import { baseApi } from "@/config/http-common";
import { LocationQueryValue } from "vue-router";

class ProcessTemplateDataService {
  getAll(page: any): Promise<any> {
    return baseApi.get("/documents/process-template/list", {
      params: { page: page },
    });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/documents/process-template/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/documents/process-template/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/documents/process-template/update/${id}`, data);
  }

  delete(id: string): Promise<any> {
    return baseApi.delete(`/documents/process-template/${id}`);
  }

  getUserActiveAuthorities(
    templateId?: string | LocationQueryValue[] | null
  ) {
    return baseApi.get(
      "/users/transfer-authority/get-user-active-authorities",
      {
        params:
          templateId !== undefined && templateId !== null
            ? { templateId }
            : {},
      }
    );
  }
}

export default new ProcessTemplateDataService();
